import { render, staticRenderFns } from "./CookiesConsent.vue?vue&type=template&id=1ef3c9de&scoped=true&"
import script from "./CookiesConsent.vue?vue&type=script&lang=js&"
export * from "./CookiesConsent.vue?vue&type=script&lang=js&"
import style0 from "./CookiesConsent.vue?vue&type=style&index=0&id=1ef3c9de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef3c9de",
  null
  
)

export default component.exports